import { render, staticRenderFns } from "./SelectionExtraService.vue?vue&type=template&id=326d3204"
import script from "./SelectionExtraService.vue?vue&type=script&lang=js"
export * from "./SelectionExtraService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports